import { Pinia, Store } from 'pinia-class-component';
import { Inventory, InventoryUiClient } from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
  id: 'InventoryStore',
  name: 'InventoryStore',
})
export default class InventoryStore extends Pinia {
  private readonly inventoryApi = initClient(InventoryUiClient);

  //data
  private _loadingPromise: Promise<Inventory[]> | null = null;
  private _inventories: Inventory[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get inventories(): Inventory[] {
    return this._inventories;
  }

  get inventoriesById(): Map<number, Inventory> {
    return new Map(this._inventories.map(e => [e.id!, e]));
  }

  //actions
  clear(): void {
    this._inventories.splice(0);
  }

  setInventories(inventories: Inventory[]): void {
    this._inventories.splice(0);
    this._inventories.push(...inventories);
  }

  remember(inventory: Inventory): void {
    const index = this._inventories.findIndex(e => e.id == inventory.id);
    if (index >= 0) {
      this._inventories.splice(index, 1, inventory);
    } else {
      this._inventories.push(inventory);
    }
  }

  forget(inventory: Inventory): void {
    const index = this._inventories.findIndex(e => e.id == inventory.id);
    if (index >= 0) {
      this._inventories.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.inventoryApi.getData(undefined, undefined);
      const duties = await this._loadingPromise;
      this.setInventories(duties);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._inventories.length > 0) {
      return;
    }
    return await this.reload();
  }
}